import { Component, Vue } from 'vue-property-decorator';
import { modulesRoutes } from '@/router';

@Component
export default class IsModulesMixin extends Vue {
  get isModules() {
    return modulesRoutes.indexOf(this.$route.name) !== -1;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isModules.ts